export default "__VITE_ASSET__52097d50__"